import { DATE_FORMAT_MMM_D_YYYY } from 'constants/formats';
import dayjs from 'dayjs';
import { IGetPaymentsHistoryResponse } from 'services/payments/payments/types';

import { IPaymentHistoryEntity } from 'interfaces/payments';

import { capitalizeOnlyFirstLetter } from 'helpers/capitalizeOnlyFirstLetter';
import { formatCurrency } from 'helpers/numbers';

import { IPaymentHistoryRow } from './components/PaymentHistory/columns';

const getPlan = (plan: string) => {
  const formattedPlan = plan.split('_')[1];
  return capitalizeOnlyFirstLetter(formattedPlan);
};

export const getPaymentsHistory = (locale: string, data?: IGetPaymentsHistoryResponse): IPaymentHistoryRow[] => {
  if (!data) {
    return [];
  }
  dayjs.locale(locale);

  return data.content.map((item: IPaymentHistoryEntity) => ({
    date: dayjs(item.createdAt).format(DATE_FORMAT_MMM_D_YYYY),
    cost: formatCurrency(item.order.subscription.price),
    plan: getPlan(item.order.subscription.code),
    operationId: item.operationId,
    receipt: item.receipt,
    id: item.operationId,
    status: item.status,
  }));
};
